import React, { useState, useEffect, useRef } from 'react';


import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, redirect } from 'react-router-dom';
import i18n from './i18n';

import {
  Button, Container, Row, Col,
  // Card, CardBody, CardTitle, CardSubtitle, CardText 
} from 'reactstrap';

// css style can be found in App.css file

import shareIconImg from './images/icon-share-wht.png';

// export default function LanguageSwitcher() {
const ShareLink = ({ title, text, url }) => {
    // title, text, url
  const isMountedRef = useRef();
    const { t } = useTranslation();

    const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: text,
          url: url,
        });
        // console.log('Content shared successfully');
      } catch (error) {
        // console.error('Error sharing:', error);
      }
    } else {
      // Fallback for browsers that do not support the Web Share API
      // alert('Web Share API is not supported in this browser.');
      // You could also provide a fallback like copying the URL to the clipboard
      // or using a third-party social media sharing library here.
    }
  };

    useEffect(() => {
  
      isMountedRef.current = true;
  
      return () => {
        isMountedRef.current = false;
        // console.log("LanguageSwitcher unmount")
  
      };
    }, []);
  

  return (
    <Button className='share-link color-text-white font-poppins' color='link' onClick={handleShare}>
        {t('taxiGameIntroShareLink')} <img src={shareIconImg} alt={t('taxiGameIntroShareLink')} className='icon-share img-inline-block'/>
    </Button>
  );
}

export default ShareLink;